module.exports = __webpack_public_path__ + "img/114_thumbnail.1d15cf61.jpg";